const article = {
    slug: "mame-kurogouchi",
    category: "BRAND BUYBACK",
    listTitle: "Mame Kurogouchi（マメクロゴウチ）買取",
    listDescription:
      "黒河内真衣子の記憶、シーズン背景、テキスタイル、工芸技法まで確認して査定するEnclopediaのブランド別買取ページ。",
  
    seo: {
      title:
        "マメクロゴウチ買取｜Mame Kurogouchiを背景まで査定するEnclopedia",
      description:
        "Mame Kurogouchi（マメクロゴウチ）の買取ならEnclopediaへ。黒河内真衣子のシーズン背景、コード刺繍、レース、ジャカード、希少性まで確認。LINE事前査定から送料無料の宅配買取へご案内します。",
      keyword:
        "マメクロゴウチ 買取,Mame Kurogouchi 買取,マメ クロゴウチ 買取,mame 買取,マメ 買取,マメクロゴウチ 高価買取,Mame Kurogouchi 高価買取,マメクロゴウチ 宅配買取,Mame Kurogouchi ワンピース 買取,Mame Kurogouchi ドレス 買取,コード刺繍 買取,黒河内真衣子,デザイナーズブランド 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/mame-kurogouchi",
    },
  
    hero: {
      label: "MAME KUROGOUCHI BUYBACK",
      number: "01 / BUYBACK",
      titleLines: [
        "Mame Kurogouchi買取。",
        "マメクロゴウチの記憶と技法まで査定します。",
      ],
      body:
        "Enclopediaは、Mame Kurogouchiを「人気のワンピース」という理由だけで判断しません。\n黒河内真衣子のダイアリー、長野の風景、旅や日常の記憶が、どのような素材と技法によって一着へ変換されたのかを確認します。\nコード刺繍、レース、ジャカード、ニット、プリントなどの表現を、シーズン背景、希少性、現在の需要まで含めて査定します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "autobiographical creation",
        "Japanese craftsmanship",
        "textile archive",
        "mame kurogouchi",
      ],
      visualLabel: "MEMORY INTO TEXTILE",
      visualTitle: [
        "装飾の美しさだけでなく、",
        "記憶が布になる過程を見る。",
      ],
      image: "media/archive_fashion/buyback-mame-kurogouchi.png",
      imageAlt:
        "Mame Kurogouchi マメクロゴウチ買取とコード刺繍やテキスタイルを表現したメイン画像",
    },
  
    thesis: {
      text:
        "Mame Kurogouchiの価値は、消えていく記憶や感覚を、工芸とテクノロジーによって触れられる布へ変えることにある。",
      keywords: ["memory", "craft", "textile"],
    },
  
    intro: {
      label: "02 / DESIGNER & BRAND",
      titleLines: [
        "Mame Kurogouchiは、",
        "記憶を布へ変えるブランド。",
      ],
      body:
        "デザイナーの黒河内真衣子は長野県に生まれ、文化服装学院で学んだ後、三宅デザイン事務所で経験を積みました。2010年に黒河内デザイン事務所を設立し、自身のブランドをスタート。2014年に毎日ファッション大賞新人賞・資生堂奨励賞、2017年には第1回FASHION PRIZE OF TOKYOを受賞し、2018年からパリでコレクションを発表しています。\n\n制作の出発点となるのは、黒河内自身が日々書き留めるダイアリーです。幼少期を過ごした長野の風景、旅先で見た器、部屋に差し込む光、押し花、夢、誰かとの会話。個人的で小さな記憶が、色、柄、シルエット、テキスタイルへ展開されます。\n\nただし、Mame Kurogouchiは記憶を服の表面へ図柄として貼り付けるブランドではありません。光の揺れ、雪や氷の透明感、器の表面、植物の輪郭といった感覚を、織り、編み、染め、刺繍、素材の重なりによって再構築します。服は記憶の説明ではなく、もう一度その感覚に触れるための媒体になっています。",
    },
  
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つのMame Kurogouchi査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "記憶とシーズン背景を見る",
          text:
            "どのコレクションに属し、黒河内真衣子のどのような経験、風景、工芸、物質から生まれた服なのかを確認します。",
        },
        {
          number: "02",
          title: "テキスタイルと技法を見る",
          text:
            "コード刺繍、レース、ジャカード、ニット、染色、プリントなど、表面の華やかさだけでなく、素材開発と製造技法まで見ます。",
        },
        {
          number: "03",
          title: "身体との関係と希少性を見る",
          text:
            "首元、袖、背中、ウエストに描かれる曲線、布と肌の間に生まれる余白、流通量、サイズ、状態、再入手難度まで含めて査定します。",
        },
      ],
    },
  
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "Mame Kurogouchiの主要アイテムを、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "ワンピース・ドレス",
          text:
            "レーススリーブドレス、刺繍ドレス、クラシックドレスなど、ブランドを象徴するカテゴリー。シルエット、素材、シーズン、需要を個別に確認します。",
        },
        {
          tag: "ITEM 02",
          title: "コード刺繍アイテム",
          text:
            "立体的なコード刺繍を使用したドレス、トップス、バッグ、シューズは、Mame Kurogouchiを識別する重要な表現として丁寧に評価します。",
        },
        {
          tag: "ITEM 03",
          title: "レース・ジャカード・オリジナルテキスタイル",
          text:
            "植物、器、縄文文様、風景などを独自の織りやレースへ変換したアイテムは、柄の美しさだけでなくシーズンの物語まで確認します。",
        },
        {
          tag: "ITEM 04",
          title: "ニット・シアートップス",
          text:
            "複数の編み組織、透け感、立体的なモチーフ、身体に沿う曲線が特徴的なニットやトップスも積極的に査定します。",
        },
        {
          tag: "ITEM 05",
          title: "コート・ジャケット・セットアップ",
          text:
            "柔らかな曲線と構築性を両立したアウター、テーラリング、セットアップは、素材、仕立て、シーズン性を含めて評価します。",
        },
        {
          tag: "ITEM 06",
          title: "バッグ・シューズ・アクセサリー",
          text:
            "コード刺繍バッグ、透明なPVCバッグ、ガラスアクセサリー、曲線的なシューズなど、服と共通する造形を持つ小物も対象です。",
        },
        {
          tag: "ITEM 07",
          title: "初期アーカイブ・ランウェイ登場品",
          text:
            "旧mame表記を含む初期作品、公式ルックやランウェイで使用された型、流通数の少ないコレクションピースもご相談ください。",
        },
      ],
    },
  
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "Mame Kurogouchiのアイテム。",
      ],
      intro:
        "査定額はシーズン、状態、市場需要によって変動します。Enclopediaでは、定価や新しさだけでなく、ブランドの思想がどれだけ一着へ凝縮されているかを確認します。",
      items: [
        {
          index: "01",
          title: "コード刺繍やレースを用いた象徴的なドレス",
          text:
            "ブランドを代表する技法と、身体を美しく見せるカッティングが組み合わされたドレスやワンピースは、中古市場でも需要を確認しやすいカテゴリーです。",
        },
        {
          index: "02",
          title: "シーズンテーマを担うオリジナルテキスタイル",
          text:
            "マーブルプリント、縄文文様、金継ぎ、植物、器など、コレクションの着想を独自の生地へ変換したアイテムを丁寧に見ます。",
        },
        {
          index: "03",
          title: "完売品・近年の人気モデル・希少サイズ",
          text:
            "需要に対して流通量が少ない型、人気カラー、状態の良い近年作品は高い評価につながる場合があります。",
        },
        {
          index: "04",
          title: "来歴を確認できる初期アーカイブ",
          text:
            "古いだけで高額になるわけではありませんが、初期の重要作品、ルック使用品、資料性の高い服は、現在の需要と保存状態を踏まえて個別に評価します。",
        },
      ],
    },
  
    quote: {
      textLines: [
        "記憶を装飾として引用するのではなく、",
        "光、温度、身体の感覚ごと布へ定着させる。",
      ],
    },
  
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定では、",
        "見落とされやすいMame Kurogouchiの価値。",
      ],
      intro:
        "Mame Kurogouchiの価値は、レースや刺繍の量だけでは決まりません。着想、技法、身体との関係が一体となって初めて、一着の意味が現れます。",
      items: [
        {
          index: "01",
          title: "刺繍があるかだけで判断しない",
          text:
            "同じ刺繍でも、シーズンの物語、技法、密度、立体性、配置によって意味と市場評価が異なります。",
        },
        {
          index: "02",
          title: "女性らしい服という説明で終わらせない",
          text:
            "肌を見せる部分と覆う部分、柔らかさと構築性、繊細さと強さ。その緊張関係がどのように設計されているかを確認します。",
        },
        {
          index: "03",
          title: "素材の状態と修復可能性まで見る",
          text:
            "レースの引っ掛け、刺繍糸の浮き、シアー素材の傷、PVCの変色やべたつきなど、素材固有の経年変化を細かく確認します。",
        },
        {
          index: "04",
          title: "年代だけで一律に判断しない",
          text:
            "新しいシーズンが高値になりやすい場合はありますが、過去作でも象徴性、希少性、現在の需要が高い作品は個別に評価します。",
        },
      ],
    },
  
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: ["LINE事前査定から、", "宅配買取へ。"],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "全体写真、ブランドタグ、品質表示タグ、品番、サイズ、状態が分かる写真をお送りください。シーズンや商品名が不明でも確認します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "事前査定後、本査定をご希望の場合は申込フォームへ。宅配キットの要否も選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。レースや刺繍が引っ掛からないよう畳み、付属品がある場合は一緒にお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後、状態、真贋、シーズン、技法、市場性を確認。金額にご納得いただければ、ご指定口座へ入金します。",
        },
      ],
    },
  
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "一着の背景まで確認する宅配買取。",
      ],
      intro:
        "商品名やシーズンが分からない場合も、まずはLINEで写真を確認してから進められます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "写真とタグ情報から事前確認できるため、査定対象か分からない服もご相談いただけます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合は、そのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
  
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "Mame Kurogouchi買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "Mame Kurogouchi（マメクロゴウチ）の買取相場はいくらですか？",
          answer:
            "買取相場はシーズン、品番、カテゴリー、状態、現在の需要によって異なります。ワンピース、コード刺繍、オリジナルテキスタイルなどは需要が高い場合がありますが、公開されている過去の価格だけで判断せず、現在の市場を確認して査定します。",
        },
        {
          question:
            "どのようなマメクロゴウチが高価買取につながりやすいですか？",
          answer:
            "コード刺繍ドレス、レーススリーブドレス、オリジナルジャカード、ランウェイ登場品、完売モデル、状態の良い近年作品などは評価につながりやすい傾向があります。ただし、アイテムごとに個別判断します。",
        },
        {
          question:
            "旧ブランド名のmame表記でも買取できますか？",
          answer:
            "査定可能です。旧mame表記のアイテムも、年代、シーズン、デザイン、保存状態、現在の需要を確認します。古いという理由だけで一律に評価することはありません。",
        },
        {
          question:
            "ワンピース以外のMame Kurogouchiも買取できますか？",
          answer:
            "可能です。ブラウス、ニット、スカート、パンツ、ジャケット、コート、バッグ、シューズ、アクセサリーなど幅広く対応します。",
        },
        {
          question:
            "シーズンや正式な商品名が分からなくても査定できますか？",
          answer:
            "可能です。全体、ブランドタグ、品質表示タグ、品番、特徴的な刺繍や柄が分かる写真をLINEでお送りください。確認できる範囲で商品とシーズンを調査します。",
        },
        {
          question:
            "レースの引っ掛けや刺繍のほつれがあっても買取できますか？",
          answer:
            "状態によっては査定可能です。レースの破れ、刺繍糸の浮き、毛玉、シミ、PVCの変色やべたつきなどがある場合は、事前に該当箇所の写真をお送りください。",
        },
        {
          question:
            "付属品がなくても査定できますか？",
          answer:
            "服本体のみでも査定可能です。替えボタン、ベルト、インナー、保存袋、箱など、販売時の付属品が揃っている場合は一緒にお送りください。",
        },
      ],
    },
  
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "Mame Kurogouchiの価値をご相談ください。",
      ],
      body:
        "人気や定価だけでなく、その服にどのような記憶、技法、シーズンの物語が残されているのかまで確認します。\n写真による事前査定から、Mame Kurogouchiを理解した宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };
  
  export default article;